export default __webpack_public_path__ + "static/media/015-chick.142b75bd.svg";